import axios from "axios";
import { Message, Loading } from "element-ui";
import store from "@/store";
import router from "@/router";
import Vue from 'vue'

let loading = null;

const baseURL = 'https://www.sxjgrcw.cn/'

const service = axios.create({
  baseURL
  // baseURL: " https://ht.changanjoin.com" // url = base url + request url
});
// request interceptor

service.interceptors.request.use(
  config => {
    let token = store.state.token;
    let tenantId = store.state.tenantId;
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`
        // "tenant-id": tenantId
      };
    }
    if (config.noTen == 1) {
    } else {
      config.headers['tenant-id'] = tenantId
    }

    loading = Loading.service({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    return config;
  },
  error => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    // Vue.prototype.$endLoading()
    loading.close();
    const res = Object.keys(response.data).includes('code')?response.data:{code:0,data:response.data};
    // const res = response.data;
    // console.log(res)
    if (res.code === 0) {
      return res;
    } else if (res.code === 401) {
      Message({
        message: "登录过期，请重新登录！",
        type: "error"
      });
      store.commit("REMOVE_TOKEN");
      store.commit("REMOVE_TENANTID");
      let that = Vue.prototype
      let promise = that.tim.logout();
      promise.then(function(imResponse) {
              console.log(imResponse.data); // 登出成功
      }).catch(function(imError) {
              console.warn('logout error:', imError);
      });
      setTimeout(() => {
        router.replace("/user_login");
      }, 800);
      return;
    } else {
      Message.error(res.msg);
    }
    return Promise.reject(res.msg);
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: error.msg,
      type: "error"
    });
    return Promise.reject(error);
  }
);

const get = (url, params, loading = false) =>
  service({
    method: "get",
    url,
    params,
    loading
  });

const post = (url, params, data, loading = true) =>
  service({
    method: "post",
    url,
    params,
    data,
    loading
  });

const put = (url, params, data, loading = true) =>
  service({
    method: "put",
    url,
    params,
    data,
    loading
  });

const del = (url, params, data, loading = true) =>
  service({
    method: "delete",
    url,
    params,
    data,
    loading
  });

export { get, post, put, del };
export { baseURL }
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js